type SectionHeadProps = {
  kicker: string;
  title: string;
  desc?: string;
  tag?: string;
  align?: "left" | "center";
};

export default function SectionHead({ kicker, title, desc, tag, align = "left" }: SectionHeadProps) {
  const center = align === "center";
  return (
    <div
      className={`mb-7 flex w-full flex-col gap-4 md:mb-9 ${
        center ? "items-center text-center" : "items-start md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={center ? "flex flex-col items-center" : ""}>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">{kicker}</p>
        <h4 className="mt-2 flex items-center gap-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
          {tag && (
            <span className="inline-flex h-8 items-center rounded-md bg-primary-600 px-2.5 text-sm font-bold text-background-50 md:h-9">
              {tag}
            </span>
          )}
          {title}
        </h4>
        {desc && (
          <p className={`mt-3 max-w-xl text-sm leading-6 text-foreground-500 md:text-[15px] ${center ? "mx-auto" : ""}`}>
            {desc}
          </p>
        )}
      </div>
    </div>
  );
}